import { axiosInstance as request } from '@api/rest.service'

const api = '/product-types'

/**
 * @description GET /product-types
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCT_TYPES = () => request.get(api)

/**
 * @description POST /product-types
 * @returns {AxiosPromise<any>}
 */
export const CREATE_PRODUCT_TYPE = payload => request.post(api)

/**
 * @description PUT /product-types/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_PRODUCT_TYPE = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /product-types/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCT_TYPE_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /product-types/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_PRODUCT_TYPE = id => request.delete(`${api}/${id}`)
